import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

// Composes a cron string from the Repeats / day / time pickers.
//
// Mirrors cron_controller.js but drives shadcn selects, which post through a hidden input -- so there is
// no .options collection to walk and visibility toggles a wrapper rather than the field.
export default class extends Controller {
  static targets = ["repeats", "dayOfWeek", "dayOfMonth", "timeOfDay", "cadence", "weeklyWrapper", "monthlyWrapper",
    "nextSend"];

  connect() {
    // Also mounted on forms that carry no schedule pickers, purely for #submit: a missing target here
    // would throw and leave submit unbound.
    if (this.hasRepeatsTarget) this.updateFields();
  }

  // The dialog's close paths (button, Escape, backdrop) all dispatch ui--dialog:before-close, which is
  // cancelable -- so one guard here covers every one of them.
  get unsavedChanges() {
    return this.application.getControllerForElementAndIdentifier(this.element, "ui--unsaved-changes");
  }

  confirmCloseIfDirty(event) {
    const unsaved = this.unsavedChanges;
    if (!unsaved?.dirtyValue) return;

    if (window.confirm("You have unsaved changes. Are you sure you want to close?")) {
      unsaved.clearDirty();
    } else {
      event.preventDefault();
    }
  }

  async submit(event) {
    event.preventDefault();
    const form = event.target;
    // Always POST: form_with carries the real verb in the _method field, which FormData picks up.
    // request.js renders the returned stream itself for ok/422, which is what replaces the dialog body.
    await post(form.action, { body: new FormData(form), responseKind: "turbo-stream" });
  }

  onChangeRepeat() {
    this.updateFields();
    this.onChangeSchedule();
  }

  // The change handlers go through here rather than calling calculateCadence directly, because
  // calculateCadence also runs on connect -- and the rendered next-send belongs to the SAVED cadence,
  // so it is correct on open and stale only once a picker moves.
  onChangeSchedule() {
    this.calculateCadence();
    if (this.hasNextSendTarget) this.nextSendTarget.hidden = true;
  }

  updateFields() {
    const repeats = this.repeatsTarget.value;
    this.weeklyWrapperTarget.classList.toggle("hidden", repeats !== "weekly");
    this.monthlyWrapperTarget.classList.toggle("hidden", !["monthly", "quarterly"].includes(repeats));
    this.calculateCadence();
  }

  calculateCadence() {
    const [hour, minuteInput] = this.timeOfDayTarget.value.split(":");
    const minute = minuteInput === "30" ? "30" : "0";
    const repeats = this.repeatsTarget.value;

    const dayOfMonth = ["monthly", "quarterly"].includes(repeats) ? this.dayOfMonthTarget.value : "*";
    const monthOfYear = repeats === "quarterly" ? "*/3" : "*";
    const dayOfWeek = repeats === "weekly" ? this.dayOfWeekTarget.value : "*";

    this.cadenceTarget.value = `${minute} ${hour} ${dayOfMonth} ${monthOfYear} ${dayOfWeek}`;
  }
}
